import Box from "@mui/material/Box";
import React from "react";

import { formKey } from "../../../hooks/useQuoteBoxStructure";
import {
  CardRow,
  StructureSection,
} from "../OpenBoxQuotes/BoxStructureFields";
import { NumberedSectionTitle } from "../OpenBoxQuotes/FormFields";
import { useStyles } from "../styles";
import {
  FRONT_WALL,
  HYDRAULIC_TON,
  NoteCard,
  REAR_FRAME,
  REAR_OPENING,
  ROOF_TYPE,
  SIDE_FLAP,
  SideDoorOpeningsCard,
  TypeCard,
} from "./BoxStructureCards";

const closedKey = (suffix: string) => formKey(`CLOSED_BOX.${suffix}`);

const BoxStructure = () => {
  const styles = useStyles();

  return (
    <Box className={styles.inputCard}>
      <NumberedSectionTitle
        number={2}
        titleKey={formKey("SECTIONS.BOX_STRUCTURE")}
      />

      <StructureSection titleKey={closedKey("SECTIONS.ROOF")} plain>
        <CardRow columns={1}>
          <TypeCard cardKey="roofType" options={ROOF_TYPE} />
        </CardRow>
      </StructureSection>

      <StructureSection titleKey={closedKey("SECTIONS.FRONT_WALL_AND_FRAME")}>
        <CardRow columns={3}>
          <TypeCard cardKey="frontWall" options={FRONT_WALL} />
          <TypeCard cardKey="rearFrame" options={REAR_FRAME} />
          <NoteCard cardKey="frontWallReinforcement" />
        </CardRow>
      </StructureSection>

      <StructureSection titleKey={closedKey("SECTIONS.OPENINGS_AND_DOORS")}>
        <CardRow columns={2}>
          <SideDoorOpeningsCard />
          <TypeCard cardKey="rearOpening" options={REAR_OPENING} />
        </CardRow>
        <CardRow columns={2}>
          <TypeCard
            cardKey="hydraulicSide"
            options={HYDRAULIC_TON}
            selectLabelKey={closedKey("FIELDS.TON")}
          />
          <TypeCard cardKey="sideCompletionFlap" options={SIDE_FLAP} />
        </CardRow>
      </StructureSection>
    </Box>
  );
};

export default BoxStructure;
